var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('h3',[_vm._v("欢迎使用")]),_c('h1',[_vm._v("统一管理平台")]),(_vm.addRouters.length === 0)?_c('p',[_vm._v(" 当前账号并未配置任何权限，请联系 "),_c('strong',[_vm._v("系统管理员")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }